"use strict";

exports.__esModule = true;
exports.default = first;
var _initial = _interopRequireDefault(require("./initial.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Get the first element of an array. Passing **n** will return the first N
// values in the array. The **guard** check allows it to work with `_.map`.
function first(array, n, guard) {
  if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
  if (n == null || guard) return array[0];
  return (0, _initial.default)(array, array.length - n);
}